import { useState } from "react";
import styled from "styled-components";
import media from "styled-media-query";
import { CoorporateScheme } from "client-v2";
import { useSelector } from "react-redux";
import { State } from "../../../redux";

import { Button, Text, Counter } from "@adoptaunabuelo/react-components";
import { Pencil } from "lucide-react";
import VideoModal from "../../../components/modal/VideoModal";
import SectionContainer from "../../../components/container/SectionContainer";
import UnaCartaParaUnAbueloLogo from "../../../assets/logo/UnaCartaParaUnAbuelo";
import { useNavigate } from "react-router";

const isScreen02: any = "1050px";

const SectionContainerStyled = styled(SectionContainer)`
	justify-content: center;
`;
const ButtonStyled = styled(Button)`
	width: fit-content;
	padding: 0px 32px;
	${media.lessThan("medium")`
        width: 100%;
    `}
`;
const StampsContainerView = styled.div`
	display: flex;
	flex-direction: row;
	gap: 48px;
`;
const StampsContainer = styled.div`
	position: relative;
	margin-bottom: 38px;
	${media.lessThan("medium")`
		display: flex;
		justify-content: flex-end;
    `}
`;
const StampView = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 132px;
	height: 110px;
	background-size: cover;
`;
const StampLogo = styled.img`
	width: 90px;
	height: 54px;
	object-fit: contain;
`;
const AUAStampLogo = styled.div`
	position: absolute;
	top: 32px;
	left: -64px;
	width: 80px;
	transform: rotate(10deg);
`;
const DataContainer = styled.div`
	display: flex;
	flex-direction: column;
	${media.lessThan("medium")`
        flex: 1;
		justify-content: center;
    `}
`;
const Title = styled(Text)`
	margin-bottom: 32px !important;
	${media.lessThan(isScreen02)`
        font-size: 32px !important;
		line-height: 42px !important;
		margin-bottom: 32px !important;
    `}
`;

const Home = (props: Props) => {
	const navigate = useNavigate();
	const translation = useSelector(
		(state: State) => state.location.translation,
	);
	const isMobile = useSelector((state: State) => state.screen.isMobile);
	const [showVideo, setShowVideo] = useState(false);

	return (
		<>
			<VideoModal
				isVisible={showVideo}
				url={"https://www.youtube.com/watch?v=nalM0N80OYA"}
				onFinish={() => setShowVideo(false)}
				onClose={() => setShowVideo(false)}
			/>
			<SectionContainerStyled
				childrenProps={{ style: { margin: 0 } }}
				buttonProps={
					isMobile && {
						style: {
							backgroundColor: props.corporate.color?.main,
						},
						children: (
							<>
								<Pencil
									color={props.corporate.color?.third}
									height={20}
									width={20}
								/>
								<Text
									type="b1"
									weight="medium"
									style={{
										color: props.corporate.color?.third,
									}}
								>
									Escribir mi carta
								</Text>
							</>
						),
						onClick: props.onFinish,
					}
				}
			>
				<DataContainer>
					<StampsContainerView>
						<UnaCartaParaUnAbueloLogo
							height={76}
							width={107}
							version="2025"
						/>
						{props.corporate.logo && (
							<StampsContainer>
								<StampView
									style={{
										backgroundImage: `url(${require("../../../assets/images/letter/stamp_white.png")})`,
									}}
								>
									<StampLogo src={props.corporate.logo.url} />
								</StampView>
								<AUAStampLogo>
									<UnaCartaParaUnAbueloLogo version="round" />
								</AUAStampLogo>
							</StampsContainer>
						)}
					</StampsContainerView>
					<Title type="h2" weight="semibold">
						Envía una carta a una persona mayor
					</Title>
					<Counter
						amount={props.amount}
						color={props.corporate.color?.main}
						height={53}
						width={36}
						fontSize={40}
					/>
					<Text
						type="p"
						style={{ marginTop: 8, marginBottom: "10%" }}
					>
						{translation.letter_home_counter}
					</Text>
				</DataContainer>
				{!isMobile && (
					<ButtonStyled
						style={{
							backgroundColor: props.corporate.color?.main,
							color: props.corporate.color?.third,
						}}
						icon={
							<Pencil
								color={props.corporate.color?.third}
								height={20}
								width={20}
							/>
						}
						onClick={props.onFinish}
					>
						{translation.letter_button_go}
					</ButtonStyled>
				)}
			</SectionContainerStyled>
		</>
	);
};
export default Home;
export interface Props {
	corporate: CoorporateScheme;
	amount: number;
	onFinish: () => void;
}
